import apps from './apps/apps.module.js';
import auth from './auth/auth.module.js';
import retentionTrends from './retention-trends/retention-trends.module.js';
import adoptionTrends from './adoption-trends/adoption-trends.module.js';
import trendsSettings from './trends/trends-settings.module.js';
import coreEvents from './core-events/core-events.module.js';
import devicesConnection from './devices-connection/devices-connection.module.js';
import experiments from './experiments/experiments.module.js';
import features from './features/features.module.js';
import globalFilters from './global-filters/global-filters.module.js';
import insights from './insights/insights.module.js';
import metadata from './metadata/metadata.module.js';
import productLines from './product-lines/product-lines.module.js';
import savedFilters from './saved-filters/saved-filters.module.js';
import subscription from './subscription/subscription.module.js';
import superSubscription from './subscription/super/super.module.js';
import trackTypes from './track-types/track-types.module.js';
import users from './users/users.module.js';
import filters from './voc-items/filters/filters.module.js';
import workflows from './workflows/workflows.module.js';

export default {
    insights,
    savedFilters,
    productLines,
    vocItems: {
        namespaced: true,
        modules: {
            filters,
        },
    },
    auth,
    experiments,
    trackTypes,
    features,
    workflows,
    retentionTrends,
    adoptionTrends,
    trendsSettings,
    devicesConnection,
    coreEvents,
    subscription: {
        ...subscription,
        modules: {
            super: superSubscription,
        },
    },
    globalFilters,
    users,
    apps,
    metadata,
};
